import { render, staticRenderFns } from "./deleteDialog.vue?vue&type=template&id=05f93372&scoped=true&"
import script from "./deleteDialog.vue?vue&type=script&lang=js&"
export * from "./deleteDialog.vue?vue&type=script&lang=js&"
import style0 from "./deleteDialog.vue?vue&type=style&index=0&id=05f93372&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f93372",
  null
  
)

export default component.exports